// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2imB4","title":"styles_title__J8P0c"};